import { render, staticRenderFns } from "./personnel_lable.vue?vue&type=template&id=2dc696d6&scoped=true&"
import script from "./personnel_lable.vue?vue&type=script&lang=js&"
export * from "./personnel_lable.vue?vue&type=script&lang=js&"
import style0 from "./personnel_lable.vue?vue&type=style&index=0&id=2dc696d6&prod&lang=scss&scoped=true&"
import style1 from "./personnel_lable.vue?vue&type=style&index=1&id=2dc696d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc696d6",
  null
  
)

export default component.exports